import React from "react";
import compass from "../../Assets/compass.png";
import grid2Img from "../../Assets/grid-2-bg.jpeg";
import grid3Img from "../../Assets/grid-3-bg.png";
import grid4Img from "../../Assets/grid-4-bg.png";
import aiPowered from "../../Assets/ai-powered.png";
import greenStar from "../../Assets/green-star.png";
import grid5Img from "../../Assets/grid-5-bg.png";
import grid6Img from "../../Assets/grid-6-bg.png";
import computerImg from "../../Assets/computer-img.png";
import openBoxImg from "../../Assets/open-box.png";
import yellowStar from "../../Assets/yellow-star.png";
import grid7Img from "../../Assets/grid-7-bg.png";
import redStar from "../../Assets/red-star.png";
import avatarGroup from "../../Assets/avatar-group.png";
import blueSemicircles from "../../Assets/blue-semicircles.png";
import certificate from "../../Assets/certificate.png";
import globImg from "../../Assets/globe.png";
import { useTranslation } from "react-i18next";

const GridSection = () => {
  const { t } = useTranslation("grid");

  return (
    <section className="grid grid-cols-8 md-max:grid-cols-4 md-max:grid-rows-[repeat(12,minmax(0,1fr))] grid-rows-7 items-start relative px-12 gap-3.5 py-12 md-max:py-10 md-max:px-6">
      <div className="col-span-3 md-max:col-span-4 h-80 row-span-2 rounded-[1.4rem] bg-radial-gradient flex flex-col justify-between py-4 px-6 relative">
        <p className="text-gradient">{t('text1')}</p>
        <p className="text-gradient font-medium text-4xl leading-[3rem] w-3/4">
          {t('text2')}
        </p>
        <img
          src={compass}
          alt="compass"
          className="object-cover absolute top-5 right-5"
        />
      </div>
      <div className="col-span-3 md-max:col-span-4 row-span-2 h-full rounded-[1.4rem] bg-radial-gradient flex flex-col justify-between py-4 px-6 relative overflow-hidden">
        <p className="text-white font-semibold z-20 text-3xl w-3/5">
          {t('text3')}
        </p>
        <img
          src={grid2Img}
          alt="compass"
          className="object-cover absolute top-0 right-0 w-full h-full"
        />
        <div className="absolute top-0 left-0 bg-gradient-to-br from-black to-transparent w-full h-full z-10 opacity-50"></div>
      </div>
      <div className="col-span-2 row-span-3 md-max:row-span-2 h-full rounded-[1.4rem] bg-radial-gradient flex flex-col justify-center items-center">
        <img src={aiPowered} alt="ai" className="object-cover" />
      </div>
      <div className="col-span-2 row-span-3 md-max:row-span-2 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-center items-center overflow-hidden">
        <img
          src={grid3Img}
          alt="teacher"
          className="object-cover absolute top-0 left-0 w-full h-full z-10"
        />
        <p className="absolute bottom-5 left-5 text-5xl md-max:text-xl z-20 text-white font-normal">
          {t('text4')}
        </p>
      </div>
      <div className="col-span-2 row-span-2 md-max:row-span-1 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-center items-center overflow-hidden">
        <img
          src={grid4Img}
          alt="teacher"
          className="object-cover absolute top-0 left-0 w-full h-full z-10"
        />
      </div>
      <div className="col-span-2 row-span-1 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-between p-5 overflow-hidden">
        <img src={greenStar} alt="star" className="object-cover size-5" />
        <p className="text-gradient font-medium text-2xl md-max:text-xl md-max:w-full w-1/2">
          {t('text5')}
        </p>
        <img
          src={computerImg}
          alt="computer"
          className="object-cover absolute top-1/2 -translate-y-1/2 md-max:scale-50 md-max:right-0 md-max:top-10 right-5 z-10"
        />
      </div>
      <div className="col-span-4 md-max:row-span-1 row-span-2 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-between p-5 overflow-hidden">
        <p></p>
        <div className="flex flex-col gap-2">
          <p className="text-gradient font-medium text-3xl md-max:text-xl w-3/5">
            {t('text6')}
          </p>
        </div>
        <img
          src={openBoxImg}
          alt="box"
          className="object-cover absolute top-1/2 -translate-y-1/2 md-max:scale-50 md-max:right-0 right-5 z-10"
        />
      </div>
      <div className="col-span-2 row-span-2 md-max:row-span-1 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-center items-center overflow-hidden">
        <img
          src={grid5Img}
          alt="teacher"
          className="object-cover absolute top-0 left-0 w-full h-full z-10"
        />
        <p className="absolute bottom-5 left-5 text-5xl md-max:text-xl md-max:w-full z-20 text-white font-normal w-1/2">
          {t('text7')}
        </p>
      </div>
      <div className="col-span-2 row-span-2 md-max:row-span-1 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-center items-center overflow-hidden">
        <img
          src={grid6Img}
          alt="teacher"
          className="object-cover absolute top-0 left-0 w-full h-full z-10"
        />
        <p className="absolute top-5 md-max:hidden left-5 text-base z-20 text-gradient font-normal">
          {t('text8')}
        </p>
        <img
          src={yellowStar}
          alt="star"
          className="object-cover size-5 absolute top-5 right-5 z-30"
        />
      </div>
      <div className="col-span-1 md-max:col-span-4 row-span-1 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-center items-center overflow-hidden">
        <img
          src={grid7Img}
          alt="teacher"
          className="object-contain absolute top-0 left-0 w-full h-full z-10"
        />
      </div>
      <div className="col-span-3 md-max:col-span-4 row-span-2 md-max:row-span-1 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-between items-start p-5 overflow-hidden">
        <img src={redStar} alt="star" className="object-cover size-5" />
        <img src={avatarGroup} alt="avatars" className="object-cover md-max:scale-75" />
        <p className="text-gradient font-medium text-3xl md-max:text-xl">
          {t('text9')}
        </p>
      </div>
      <div className="col-span-2 md-max:col-span-3 row-span-1 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-between p-5 overflow-hidden">
        <img src={blueSemicircles} alt="star" className="object-cover size-5" />
        <p className="text-gradient font-medium text-3xl md-max:text-xl">
          {t('text10')}
        </p>
        <img
          src={certificate}
          alt="computer"
          className="object-cover absolute top-1/2 -translate-y-3/4 md-max:scale-50 md-max:top-[40%] right-5 z-10"
        />
      </div>
      <div className="col-span-1 row-span-1 h-full relative rounded-[1.4rem] bg-radial-gradient flex flex-col justify-center items-center overflow-hidden">
        <img
          src={globImg}
          alt="teacher"
          className="object-cover absolute top-0 left-0 w-full h-full z-10"
        />
      </div>
    </section>
  );
};

export default GridSection;
